import { Injectable } from '@angular/core';
import { RedsoxChildrenTicketCode } from './models/redsox-children-ticket-code.model';
import { EntityState, EntityStore, StoreConfig } from '@datorama/akita';

export interface RedsoxChildrenTicketCodesState extends EntityState<RedsoxChildrenTicketCode> {}

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'redsox-children-ticket-codes', idKey: 'Id' })
export class RedsoxChildrenTicketCodesStore extends EntityStore<RedsoxChildrenTicketCodesState> {
  constructor() {
    super();
  }
}
